<template>
  <div class="chat--balloon-wrapper bot logo-wetome-wrap" ref="element">
    <div class="logo-row">
      <img class="welogo" src="../assets/wetome-1.png" />
    </div>
    <div class="logo-row">
      <img src="../assets/wetome-2.png" />
    </div>
  </div>
</template>

<script>

import {gsap} from 'gsap'

export default {
  name: 'LogoWeToMe',
  components:{
  },
  data(){
    return {

    }
  },
  methods:{
    startTransition(){
      
      var TL = gsap.timeline()
      TL
      .to('.logo-wetome-wrap', {top: 0, duration: 0.75, 
      onStart: () => {
        let elementHeight = this.$refs.element.clientHeight;
        this.$store.dispatch('triggerScrollWindow', elementHeight + 450);
      }})
      .to('.logo-wetome-wrap img', {opacity: 1,y: 0, duration: 0.75, stagger: 1.5}, '-=.5')
      .to('.welogo', {rotationX: 180, duration: .75}, '-=.75')
    }
  },
  mounted(){
    this.startTransition()
  },
  computed:{
   
  },
  watch: {
    
  }
}
</script>

<style lang="scss">
  .logo-wetome-wrap {
    position: relative;
    overflow: visible;
    max-width: 504px;
    top: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 250px;
    opacity: 1;
    .logo-row{
      position: relative;
      width: 100%;
    }
    img{
      opacity: 0;
      width: 100%;
      transform: translateY(50px);
      &.welogo{
        width: 40%;
      }
    }
    @media screen and (max-width: 768px){
      margin-top: 100px;
    }
  }
</style>